// require('./index/');
// require('./about/about.component');
// require('./portfolio/portfolio.component');
// require('./solutions');
// require('./partners/partners.component');
// require('./career/career.component');

import Index from './index/';
import About from './about/About';
import Portfolio from './portfolio/Portfolio';
import Solutions from './solutions/Solutions';
import Partners from './partners/Partners';
import Career from './career/Career';
import Footer from './Footer';

export const PageTitle = require('./PageTitle');

export {Index, About, Portfolio, Solutions, Partners, Career, Footer,};

export const IndexLinkButton = require('./IndexLinkButton');



// WEBPACK FOOTER //
// ./src/components/index.js